<template lang="pug">
	b-form-group(:label="_field.label" :description="_field.help")
		div.mb-2(v-if="value")
			b-img.mb-2(:src="value" style="max-width:100px;max-height:100px;")
		div.mb-2(v-else)
			b-alert(variant="warning" show) загруженный файл отобразится после отправки формы
		b-input-group
			b-input-group-prepend(v-if="_field.icon")
				b-input-group-text
					i(:class='_field.icon')
			b-form-file(:value="value" :name="_field.name" v-bind="_field.attrs" @input.native="input" :state="_checkState(_field.name)")
			b-form-invalid-feedback(:state="_checkState(_field.name)") {{ _invalidFeedback(_field.name) }}

</template>
<script>
	export default {
		name: 'w-file',
		props: ['value','_field','_checkState', '_invalidFeedback'],
		methods: {
			input($event){
				this.$emit('input', $event.target.files[0]);
			},
		},
	}
</script>
